import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { getJson, putJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';
import { getQueryFromSearchParameters } from '@/assets/src/search_parameter';
import { SearchParameter } from '@/assets/src/search_parameter';

const feedbackEndpoint = `${API_URL}/private/feedback`;

export interface Feedback {
  id: number;
  cognito_id: string;
  admin_has_processed: boolean;
  user_consent_to_response: boolean;
  message: string;
}

export class FeedbackClient {
  public async listFeedback(searchParameters: SearchParameter[]): Promise<Feedback[]> {
    const headers = await getAccessTokenJwtHeader();
    const query = getQueryFromSearchParameters(searchParameters);
    const endpoint = feedbackEndpoint + query;
    const response: any = await getJson(endpoint, headers);

    return response.feedback;
  }

  public async updateFeedback(id: number, adminHasProcessed: boolean): Promise<void> {
    const headers = await getAccessTokenJwtHeader();
    const data = { id, admin_has_processed: adminHasProcessed };
    await putJson(feedbackEndpoint, data, headers);
  }
}
